import { render } from "./TermsMobileGen2.vue?vue&type=template&id=37735931&scoped=true&ts=true"
import script from "./TermsMobileGen2.vue?vue&type=script&lang=ts"
export * from "./TermsMobileGen2.vue?vue&type=script&lang=ts"

import "./TermsMobileGen2.vue?vue&type=style&index=0&id=37735931&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37735931"]])

export default __exports__